export class ColumnSwitch extends window.BAO.CustomElement() {
  CURRENT_COLUMN_ATTRIBUTE = 'current-column'
  ALLOWED_STYLES = ['default', 'single']
  CLASSES = {
    default: 'clc-ProductGrid-default',
    single: 'clc-ProductGrid-single',
  }

  constructor () {
    super()

    if (!this.els.trigger.element) {
      throw new Error(
        `<${this.localName}> needs an element with data-column-switch-el=trigger to work"`,
      )
    }

    this.handleTriggerClick = this.handleTriggerClick.bind(this)
    this.cycler = new window.BAO.Cycler(this.ALLOWED_STYLES)
    this.cycler.set(
      this.cycler.items.findIndex((i) => i === this.currentColumn),
    )
  }

  connectedCallback () {
    this.els.trigger.element.addEventListener(
      'click',
      this.handleTriggerClick,
      {
        passive: true,
      },
    )
  }

  disconnectedCallback () {
    this.els.trigger.element.removeEventListener(
      'click',
      this.handleTriggerClick,
    )
  }

  async handleTriggerClick () {
    const currentColumn = this.cycler.next()

    this.setCartAttribute(currentColumn)
    this.currentColumn = currentColumn
    this.syncThemeSwitchers(currentColumn)

    window.BAO.eventBus.dispatchEvent(window.BAO.EVENTS.THEME_SWITCH, {
      currentColumn,
    })

    window.BAO.eventBus.dispatchEvent(window.BAO.EVENTS.CAROUSEL_UPDATE)
  }

  syncThemeSwitchers (currentColumn) {
    this.allOtherThemeSwitches.forEach((el) => {
      el.currentColumn = currentColumn
      el.cycler.next()
    })
  }

  setCartAttribute (column) {
    // eslint-disable-next-line compat/compat
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          current_column: column,
        },
      }),
    })
  }

  get currentColumn () {
    return (
      this.getAttribute(this.CURRENT_COLUMN_ATTRIBUTE) || this.ALLOWED_STYLES[0]
    )
  }

  set currentColumn (value) {
    this.setAttribute(this.CURRENT_COLUMN_ATTRIBUTE, value)

    this.externalEls.body.element.classList.toggle(
      this.CLASSES.default,
      value === 'default',
    )
    this.externalEls.body.element.classList.toggle(
      this.CLASSES.single,
      value === 'single',
    )
  }

  get allOtherThemeSwitches () {
    // eslint-disable-next-line compat/compat
    return Array.from(document.querySelectorAll(this.localName)).filter(
      (el) => el !== this,
    )
  }
}

if (!customElements.get('column-switch')) {
  customElements.define('column-switch', ColumnSwitch)
}
